import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import Header from './Header';
import { useUIStore, useThemeStore } from '@store';

export default function MainLayout({ children, projects, selectedProject, onProjectChange, onClientModeToggle, onNewTask, onNewProject, onEditProject }) {
  const { sidebarOpen, activeView, setActiveView } = useUIStore();
  const { theme } = useThemeStore();
  const isDark = theme === 'dark';
  const contentRef = useRef(null);

  // The content area is the scroll container: start each view at the top
  useEffect(() => {
    contentRef.current?.scrollTo({ top: 0 });
  }, [activeView]);

  const handleNewTask = () => {
    if (onNewTask) {
      onNewTask();
    }
  };

  // Fixed to the viewport: only the content area scrolls, so the sidebar
  // (and its bottom "Vista Cliente" button) always stays in view.
  const layoutStyle = {
    display: 'flex',
    height: '100vh',
    backgroundColor: isDark ? '#0f172a' : '#f1f5f9',
    transition: 'background-color 0.3s ease',
  };

  const mainStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  };

  const contentStyle = {
    flex: 1,
    overflowY: 'auto',
    padding: '24px',
    backgroundColor: isDark ? '#0f172a' : '#f1f5f9',
    color: isDark ? '#e2e8f0' : '#1e293b',
  };

  return (
    <div style={layoutStyle}>
      <Sidebar
        isOpen={sidebarOpen}
        activeView={activeView}
        onViewChange={setActiveView}
        onClientModeToggle={onClientModeToggle}
      />

      <main style={mainStyle}>
        <Header
          projects={projects}
          selectedProject={selectedProject}
          onProjectChange={onProjectChange}
          onNewTask={handleNewTask}
          onNewProject={onNewProject}
          onEditProject={onEditProject}
        />

        <div ref={contentRef} style={contentStyle}>
          {children}
        </div>
      </main>
    </div>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  projects: PropTypes.array,
  selectedProject: PropTypes.object,
  onProjectChange: PropTypes.func.isRequired,
  onClientModeToggle: PropTypes.func,
  onNewTask: PropTypes.func,
  onNewProject: PropTypes.func,
  onEditProject: PropTypes.func,
};
